import React from "react";
import { Lock } from "lucide-react";
import { Modal } from "src/components/ui/Modal";
import { Button } from "src/shadcn/ui/button";

interface FinalizeShipmentModalProps {
  open: boolean;
  shipmentId: string;
  isSubmitting: boolean;
  submitError?: string;
  onClose: () => void;
  onConfirm: () => void;
}

const FinalizeShipmentModal: React.FC<FinalizeShipmentModalProps> = ({
  open,
  shipmentId,
  isSubmitting,
  submitError,
  onClose,
  onConfirm
}) => {
  if (!open) return null;

  return (
    <Modal
      icon={<Lock className="w-6 h-6 text-warning-600" />}
      header="Finalize Shipment"
      onClose={isSubmitting ? undefined : onClose}
    >
      <div className="space-y-4">
        <p className="text-sm text-secondary-700">
          Finalize shipment <span className="font-mono font-semibold">{shipmentId}</span>?
        </p>
        <ul className="text-sm text-secondary-600 list-disc pl-5 space-y-1">
          <li>
            Shipment status moves from <span className="font-semibold">READY</span> to{" "}
            <span className="font-semibold">BOOKED</span>.
          </li>
          <li>Send PO to Active Ants.</li>
          <li>Pallets and goods description can no longer be edited (tracking + carrier remain editable).</li>
        </ul>

        {submitError && (
          <div className="rounded-md bg-error-50 border border-error-200 px-3 py-2 text-xs text-error-700">
            {submitError}
          </div>
        )}

        <div className="flex justify-end gap-3 pt-2 border-t border-secondary-200">
          <Button variant="outline" onClick={onClose} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button
            variant="default"
            onClick={onConfirm}
            disabled={isSubmitting}
            className="bg-black text-white hover:bg-gray-800"
          >
            {isSubmitting ? "Finalizing…" : "Finalize"}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export { FinalizeShipmentModal };
